import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

/**
 * Useful for exclusive groups of sliders or toggles.
 */
const Radio = (props) => {
  const { className, label, id, ...otherProps } = props;
  const classNames = classnames('form-radio', className);

  return (
    <label htmlFor={id} className={classNames}>
      <input id={id} {...otherProps} type="radio" />
      <i className="form-icon" /> {label}
    </label>
  );
};

Radio.propTypes = {
  /** Additional classes. */
  className: PropTypes.string,
  /** Optional Label to display along side the Radio. */
  label: PropTypes.string,
  /** Input id */
  id: PropTypes.string,
};

Radio.defaultProps = {
  className: '',
  label: '',
  id: '',
};

export { Radio };
